define(function (require) {
    var ko = require("knockout");
    var _ = require("underscore");
    var querystring = require("querystring");
    var FormularyResultDosagesViewModel = require("@modules/tools/formulary-search/formularyResultDosagesViewModel");

    // ctor for FormularyResultViewModel
    return function (parent, data, year) {
        var self = this;

        // db fields
        self.formularyId = ko.observable(data.FormularyId);
        self.hasAlternatives = ko.observable(data.HasAlternatives);
        self.firstSixGPI = ko.observable(data.FirstSixGPI);
        self.tradeName = ko.observable(data.TradeNameForDisplay);
        self.rawDosages = ko.observableArray(data.Dosages);
        self.alternatives = ko.observable(data.Alternatives);
        self.dosages = ko.observableArray([]);

        self.viewDetails = function () {
            parent.viewDetails(self.formularyId());
        };

        for (var i = 0; i < self.rawDosages().length; i++) {
            self.dosages.push(new FormularyResultDosagesViewModel(self, self.rawDosages()[i], year));
        }
    };
});
